import { zSidLabel } from "src/types";
import z from "zod";

export const zSysDataHistory = z.object({
  createdAt: z.string().nullish(),
  updatedAt: z.string().nullish(),
  createdBy: zSidLabel.nullish(),
  updatedBy: zSidLabel.nullish(),
});

export type ZSysDataHistory = z.infer<typeof zSysDataHistory>;
